export default __webpack_public_path__ + "static/media/MWC-Services_Start-Loop.55a53679.mp4";